import React, { useState } from "react";
import "../../../styles/navigation.css";
import { useNavigate } from "react-router-dom";
import { AdvancedImage } from "@cloudinary/react";
import { Cloudinary } from "@cloudinary/url-gen";
import logo from "../../../assets/IMGS/logo-long.png";

const Navigation = ({ setShowLoginForm }) => {
  const navigate = useNavigate();

  const handleSignUp = () => {
    setShowLoginForm(false);
  };

  const handleLogin = () => {
    setShowLoginForm(true);
  };

  return (
    <header>
      <nav className="nav-bar">
        <div className="nav-left">
          <div className="nav-logo">
            <img className="logo" src={logo} alt="" />
            {/* <AdvancedImage className="logo" cldImg={logo} /> */}
          </div>
          {/* <ul className="nav-links">
            <li onClick={() => navigate("/products")}>Products</li>
            <li onClick={() => navigate("/services")}>Services</li>
            <li onClick={() => navigate("/pricing")}>Pricing</li>
            <li onClick={() => navigate("/resources")}>Resources</li>
            <li onClick={() => navigate("/about")}>About</li>
          </ul> */}
        </div>
        <div className="">
          <button onClick={handleLogin} className="cta-button">
            Log in
          </button>
          <button onClick={handleSignUp} className="cta-button">
            Sign up
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Navigation;
